import { useTour } from '@reactour/tour';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { removeEmpty, useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import partialConstants from 'ui/partials/utils/constants';

import contactsConstants from '../../contact/utils/constants';
import c from '../utils/constants';

export default function useUpdateEvent() {
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;
  const { isOpen, setIsOpen } = useTour();

  return useMutation({
    mutationFn: async (payload: {
      id: string;
      values: Record<string, any>;
    }) => {
      if (isOpen) return setIsOpen(false);

      const api = new Api(args);

      const data = await api.put(
        await withAcl({
          account: {
            url: `/api/v1/calendar/events/${payload.id}`,
            payload: removeEmpty(payload.values),
          },
          admin: {
            // eslint-disable-next-line max-len
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/calendar/events/${payload.id}`,
            payload: removeEmpty(payload.values),
          },
        }),
      );

      return data;
    },
    onSuccess: (successData) => {
      const { data } = successData ?? {};
      const { dealId } = data ?? {};

      queryClient.invalidateQueries({ queryKey: [c.EVENTS] });
      queryClient.invalidateQueries({
        queryKey: [contactsConstants.LEADS],
      });
      queryClient.invalidateQueries({
        queryKey: [partialConstants.TAGS],
      });

      if (dealId) {
        queryClient.invalidateQueries({ queryKey: [c.LOGS, dealId] });
      }

      toastSuccess('Successfully updated event.');
    },
  });
}
